<template>
    <div class="display-value" :id="id">
        <slot>
            <span>{{ displayValue }}</span>
            <span v-if="additionalValue">
            and <ejs-tooltip :content='additionalValue' :target="'#more'+uniqueId"><span :id="'more'+uniqueId" class="more">{{ additionalValueCount }} more</span></ejs-tooltip>
            </span>
        </slot>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { library } from "@common/library/library";
import { ddStoreFilter } from "@common/ddStore";

export const displayValueCmp = {
    name: "displayValue",
    props: {
        id: {},
        value: {}
    },
    data() {
        return {
            additionalValueCount: '',
            additionalValue: '',
            limitOfShownValues: 2,
            joinString: ', ',
            uniqueId: ''
        };
    },
    created() {
        this.uniqueId = library.getUniqueID();
    },
    computed: {
        ddStoreFilter(value, cId) {
            if (!cId) cId = this.cId;
            return ddStoreFilter(value, cId);
        },
        displayValue() {
            let value = '';
            if (typeof this.value !== 'object') {
                value = this.value;
            } else if (Array.isArray(this.value)) {
                let tmpValue = [];
                if (this.limitOfShownValues > this.value.length) this.limitOfShownValues = this.value.length;
                for (let i = 0; i < this.limitOfShownValues; i++) {
                    tmpValue.push(this.value[i]);
                }
                value = tmpValue.join(this.joinString);
                if (this.limitOfShownValues !== this.value.length) {
                    this.additionalValueCount = this.value.length - this.limitOfShownValues;
                    let additionalValue = [];
                    for (let i = this.limitOfShownValues; i < this.value.length; i++) {
                        additionalValue.push(this.value[i]);
                    }
                    this.additionalValue = additionalValue.join(this.joinString);
                }
            }
            return value;
        }
    },
    components: {
        'ejs-tooltip': defineAsyncComponent(() => import('@common/syncfusion/tooltip'))
    }
};

export default displayValueCmp;
</script>

<style scoped>
    :deep(.e-control) {
        display: inline-block;
    }
    .display-value {
        cursor: default;
    }
    .display-value :deep(.more) {
        text-decoration: underline;
        font-weight: bold;
    }
</style>
